import { Dispatch } from '@reduxjs/toolkit';
import {connect} from "react-redux";

import  MyClientInputView  from "../view/view";
import { requestClientCreationFromAPI } from '../thunk/request_func';
import { RootState } from '../../../app/store';
import {actions} from '../actions/Action';
import { NewMandant } from '../typing/generalType';
import { requestDataFromAPI } from '../../MandantenTableThingy/thunk/table_tunc';

function mapStateToProps(state:RootState){
    // state:rootState includes all global variables as state
    const myprops=
    {

        client:state.MandantenInput.model.client,
        // this variable is pure local an not recommended
        localtest: "string", // fill this with value no reference
    }
    // Return the whole construct to the container itself
    return myprops;
    // NEVER Add ACtions or Functions here
}



function bindDispatchToActions(dispatch:Dispatch<any>){
    return {
        // Include/Define every funciton that might be called here
        onSubmit:(data:NewMandant)=>{
            console.log(data);
            dispatch(requestClientCreationFromAPI(data)  as any);
            console.log("Dispatch should be done");
            setTimeout(() => {
                 dispatch(requestDataFromAPI() as any);
              }, 2000);

        },
        onConfigChange:(data:any, type:string)=>{
            console.log(data,type);
            const action = actions.SetUserDetail({data:data, type});
            console.log(action);
            dispatch(action);
            console.log("Parameter SET -> DONE");
        },
    }
}

const MandantenInputContainer=connect(mapStateToProps, bindDispatchToActions)(MyClientInputView);
export default MandantenInputContainer;